import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

class StepResultFields extends React.Component {
  state = {
    stepResult: this.props.stepResult
  };

  componentDidUpdate(prevProps) {
    if(prevProps.stepResult !== this.props.stepResult) {
      this.setState({stepResult: this.props.stepResult});
    }
  }

  programDirectorValue(stepResultValue) {
    if (stepResultValue != 0) {
      return stepResultValue
    } else if (this.props.isSaiAdmin) {
      return null
    } else {
      return this.props.programDirectors[0].id
    }
  }

  instructorTrainerValue(stepResultValue) {
    if (stepResultValue != 0) {
      return stepResultValue
    } else if (this.props.isSaiAdmin) {
      return null
    } else {
      return this.props.instructorTrainer[0].id
    }
  }

  trainingCenterValue(stepResultValue) {
    if (stepResultValue != 0) {
      return stepResultValue
    } else if (this.props.isSaiAdmin) {
      return null
    } else {
      return this.props.trainingCenters[0].id
    }
  }

  render() {
    const {
      stepResult
    } = this.state;

    const {
      user,
      certificationStep,
      certificationType,
      certification,
      programDirectors,
      instructorTrainers,
      trainingCenters,
      isSaiAdmin,
      handlerAddStep,
      isLastOfStep
    } = this.props;

    return (
      <React.Fragment>
        <td>{certificationStep.name}</td>
        <td>
          <input
            className='form-control completed-on-picker'
            type='date'
            onChange={e => this.handlerChangeField(e.target.value, 'completed_on')}
            value={stepResult.completed_on ? moment(stepResult.completed_on).format("YYYY-MM-DD") : ""}
          />
        </td>
        <td>
          <select className='form-control'
            name='program_director_id'
            value={this.programDirectorValue(stepResult.program_director_id)}
            onChange={e => this.handlerChangeField(e.target.value, 'program_director_id')}>
            <option value=''>
              Select a Program Director
            </option>
            {programDirectors.map((programDirector) =>
              <option
                key={programDirector.id}
                value={programDirector.id}
              >
                {programDirector.full_name_reverse}
              </option>
            )}
          </select>
        </td>
        <td>
          <select className='form-control'
            name='program_director_id'
            value={this.instructorTrainerValue(stepResult.instructor_trainer_id)}
            onChange={e => this.handlerChangeField(e.target.value, 'instructor_trainer_id')}>
            <option value=''>
              Select a Instructor Trainer
            </option>
            {instructorTrainers.map((instructorTrainer) =>
              <option
                key={instructorTrainer.id}
                value={instructorTrainer.id}
              >
                {instructorTrainer.full_name_reverse}
              </option>
            )}
          </select>
        </td>
        <td>
          <select className='form-control'
            name='program_director_id'
            value={this.trainingCenterValue(stepResult.training_center_id)}
            onChange={e => this.handlerChangeField(e.target.value, 'training_center_id')}>
            <option value=''>
              Select a Training Center
            </option>
            {trainingCenters.map((trainingCenter) =>
              <option
                key={trainingCenter.id}
                value={trainingCenter.id}
              >
                {trainingCenter.name}
              </option>
            )}
          </select>
        </td>
        <td>
          {isLastOfStep &&
            <button
              className="btn btn-text"
              onClick={() => { handlerAddStep(certificationStep) }}
            >
              ADD STEP
            </button>
          }
          <button
            className="btn btn-block btn-pink"
            onClick={() => { this.saveStepResult() }}
          >
            SAVE
          </button>
        </td>
      </React.Fragment>
    );
  }

  handlerChangeField = (newValue, key) => {
    const stepResult = this.state.stepResult;
    !(key in stepResult) && (stepResult[key] = {});
    stepResult[key] = newValue;

    this.setState({ stepResult: stepResult });
  };

  buildDataForm = () => {
    const data = new FormData();

    Object.keys(this.state.stepResult).forEach(key => {
      let value = this.state.stepResult[key];
      data.append(`certification_step_result[${key}]`, value);
    });

    data.append(`certification_step_result[certification_id]`, this.props.certification ? this.props.certification.id : null);
    data.append(`user_id`, this.props.user.id);
    data.append(`certification_type_id`, this.props.certificationType.id);

    return data;
  };

  saveStepResult = e => {
    let that = this;

    if (this.state.loading) {
      return;
    }

    const data = this.buildDataForm();

    this.setState({ loading: true });

    const request = this.props.formType == "edit"
      ? axios.put(
          this.props.formUrl + "/" + this.state.stepResult.id,
          data
        )
      : axios.post(
          this.props.formUrl,
          data
        );

    request
      .then(request => {
        this.props.handleCertificationUpdate(request.data.certification)
        toastr.success(this.props.formType == "edit" ? "Step Updated" : "Step Created");
        this.setState({ done: true, loading: false });
      })
      .catch(function(error) {
        toastr.error("There is an error, please check");
        that.processRailsErrors(error.response.data);
        that.setState({ loading: false, done: false });
      });
  };

}

StepResultFields.propTypes = {
  certificationStep: PropTypes.object,
  certification: PropTypes.object,
  certificationType: PropTypes.object,
  stepResult: PropTypes.object,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  formType: PropTypes.string,
  formUrl: PropTypes.string,
  user: PropTypes.object,
  handleCertificationUpdate: PropTypes.func,
  isSaiAdmin: PropTypes.bool,
  handlerAddStep: PropTypes.func,
  isLastOfStep: PropTypes.bool
};

export default StepResultFields;
